import { MaybeRefOrGetter } from '@vueuse/core';

import { RequirementStepsInfo, RequirementType } from '../../schemas/requirement';

type NotIgnoredRequirementType = Exclude<RequirementType, 'agree' | 'initials' | 'manuscript' | 'rubricate'>;
export type ValidRequirementType = NotIgnoredRequirementType;

function differenceBetweenArrays<T extends unknown[], K extends unknown[]>(array1:T, array2: K) {
  const largerArray = array1.length > array2.length ? array1 : array2;
  const smallerArray = largerArray === array1 ? array2 : array1;

  return largerArray.filter((x) => !smallerArray.includes(x)) as T & K;
}

function isNotIgnored(step: RequirementType): step is NotIgnoredRequirementType {
  const ignoredSteps = new Set(['agree', 'initials', 'manuscript', 'rubricate']);

  return !ignoredSteps.has(step);
}

export function useRequirementSteps(requirementSteps: MaybeRefOrGetter<Omit<RequirementStepsInfo, 'next'> | undefined>) {
  const steps = computed(() => toValue(requirementSteps));
  const validSteps = computed(() => steps.value?.all.filter(isNotIgnored) ?? []);
  const sanitizedFinishedSteps = computed(() => steps.value?.finished.filter(isNotIgnored) ?? []);
  const missingSteps = computed(() => differenceBetweenArrays(validSteps.value, sanitizedFinishedSteps.value));
  const firstUnfilledStep = computed(() => missingSteps.value[0]);

  return {
    validSteps,
    firstUnfilledStep,
  };
}
